import React, { useEffect, useRef, useState } from 'react';

import { Link, Redirect, useLocation } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';
import { isObjectEmpty } from 'utilitys/helpers/general';

import { useProjectTreeStore } from 'store/projectContract.store';

import { getVersionDetails } from 'api/endPoints/getVersionDetails';

import NoData from 'components/common/NoData/noData';
import OverlayWithSpinner from 'components/common/OverlayWithSpinner/overlayWithSpinner';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { settingsConfig } from 'components/Settings/settingsConfig';
import { TreeProgramTopHeader } from 'components/common';

interface Props {
    to: string;
    title: string;
}

interface Version {
    versionHashCode: number;
}
export const RedirectToLast = ({ to, title }: Props) => {
    const [last, setLast] = useState<Version | null>(null);
    const { project, contract } = useProjectTreeStore();
    const { search } = useLocation();
    const mounted = useRef(false);

    useEffect(() => {
        mounted.current = true;
        const params = {
            contractId: contract?.id,
            ids: [-1],
            projectId: project?.id,
        };

        if (project) {
            getVersionDetails(params).then((response) => {
                if (mounted.current) {
                    setLast(response[0]);
                }
            });
        }
        return () => {
            mounted.current = false;
        };
    }, [project, contract]);

    const redirect =
        last !== null && last !== undefined && !isObjectEmpty(last) && last.hasOwnProperty('versionHashCode');
    const isInitial = last === null;
    const showNoData = last === undefined;

    if (redirect) {
        return <Redirect to={{ pathname: `${to}/${last?.versionHashCode}`, search: search }} />;
    }
    if (isInitial) {
        return (
            <PageContainer>
                <OverlayWithSpinner />
            </PageContainer>
        );
    }

    if (showNoData) {
        return (
            <PageContainer>
                <HeaderWrapper>
                    <TreeProgramTopHeader />
                    <BottomHeaderSection>
                        <ProgramTopHeader pageTitle={title} />
                    </BottomHeaderSection>
                </HeaderWrapper>
                <MainContent>
                    <NoData>
                        <span>No data was uploaded yet for this project. Open </span>
                        <Link
                            to={AppRoutes.buildPath(
                                AppRoutes.DASHBOARD_PLANNING_PATH,
                                executionConfig.programLibrary.link,
                            )}
                        >
                            Program Library
                        </Link>
                        <span> to upload schedule data.</span>
                    </NoData>
                </MainContent>
            </PageContainer>
        );
    }

    return null;
};
